import { render } from "./BuyMessage.vue?vue&type=template&id=7377d5e9&scoped=true&ts=true"
import script from "./BuyMessage.vue?vue&type=script&lang=ts"
export * from "./BuyMessage.vue?vue&type=script&lang=ts"

import "./BuyMessage.vue?vue&type=style&index=0&id=7377d5e9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7377d5e9"]])

export default __exports__